import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import { change, getFormValues } from 'redux-form';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import CircularProgress  from '@material-ui/core/CircularProgress';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import MediaField from './MediaField';
import restClient from '../../services/restClient';
import { appOptions } from '../../config/app';

const styles = {
  appBar: {
    position: 'relative',
  },
  flex: {
    flex: 1,
  },
  article: {
    clear: 'both',
    marginBottom: '24px',
    paddingBottom: '24px',
    borderBottom: '1px solid #ccc',
    overflow: 'hidden',
  },
  leftCol: {
    float: 'left',
    width: '300px',
  },
  rightCol: {
    paddingLeft: '324px',
  },
  chip: {
    margin: '0 0 5px 5px',
    height: '32px',
    display: 'inline-flex',
    whiteSpace: 'nowrap',
    borderRadius: '16px',
    backgroundColor: '#ddd',
    color: '#000',
    verticalAlign: 'middle',
    lineHeight: '32px',
    boxSizing: 'border-box',
    padding: '0 10px',
    maxWidth: '300px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  title: {
    marginTop: '0',
    color: '#000'
  },
  total: {
    marginBottom: '24px',
    fontWeight: '500',
    fontSize: '1.25rem'
  },
  image: {
    margin: '0 0 5px 5px',
    height: '100px',
    display: 'inline-block',
    verticalAlign: 'middle'
  },
  thumbnail: {
    width: '100%',
    display: 'block',
    marginBottom: '5px',
  },
  media: {
    verticalAlign: 'middle'
  },
  loading: {
    textAlign: 'center',
    fontSize: '2rem',
  }
};

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}

class CrawledArticlesDialog extends React.Component {
  state = {
    open: false,
    articles: null,
    logs: null,
    count: null,
    value: 0
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  handleClickOpen = () => {
    this.setState({ open: true, articles: null, logs: null, count: null, value: 0 });
    const { record } = this.props;
    if(record.type && record.id && record.domain && record.start_urls && record.start_urls.length){
      const apiClient = restClient(appOptions);
      apiClient('CRAWL', 'mediasources/crawl', {data: record}).then(res => {
          this.setState({ articles: res.data.articles, logs: res.data.logs, count: res.total});
      });
    }
};

  handleClose = () => {
    this.setState({ open: false });
  };

  addCategory = (category) => {
    const { record } = this.props;
    const { categories } = record;
    categories.splice(0, 0, {name: category, ref: "99", type: "text", order: 1});
    
    this.props.changeCategories(categories);
  }

  render() {
    const { classes } = this.props;
    const { value } = this.state;
    return (
      <div>
        <Button variant="outlined" color="primary" onClick={this.handleClickOpen}>
          Crawl
        </Button>
        <Dialog
          fullScreen
          open={this.state.open}
          onClose={this.handleClose}
          TransitionComponent={Transition}
        >
          <AppBar className={classes.appBar}>
            <Toolbar>
              <IconButton color="inherit" onClick={this.handleClose} aria-label="Close">
                <CloseIcon />
              </IconButton>
              <Typography variant="h6" color="inherit" className={classes.flex}>
                Crawled articles
              </Typography>
            </Toolbar>
          </AppBar>
          {this.state.count === null && <div className={classes.loading}>Please wait...<CircularProgress color="secondary" /></div>}
          {this.state.count !== null && <AppBar position="static" color="secondary">
          <Tabs value={value} onChange={this.handleChange}>
            <Tab label="Articles" />
            <Tab label="Logs" />
          </Tabs></AppBar>}

          {value === 0 && <TabContainer>
          {this.state.count !== null && <div className={classes.total}>Total articles: {this.state.count}</div>}
          {this.state.articles && this.state.articles.map(a => (
            <div className={classes.article} key={a._id}>
                <div className={classes.leftCol}>
                    <div><a rel="noopener noreferrer" href={a._id} target="_blank"><img src={a.thumbnail} alt={a.thumbnail} className={classes.thumbnail} /></a></div>
                    <div>Date: <span title={a.publish_date} className={classes.chip}>{a.publish_date}</span></div>
                    <div>Author: <span title={a.author} className={classes.chip}>{a.author}</span></div>
                    <div>Site categories: {a.source_category.map(c => <Button key={c} onClick={() => this.addCategory(c)} title={'Add to mapped categories: '+c} className={classes.chip}>{c}</Button>)}</div>
                    <div>Mapped category: <span title={a.category.name} className={classes.chip}>{a.category.name}</span></div>
                </div>
                <div className={classes.rightCol}>
                    <h2 className={classes.title}><a rel="noopener noreferrer" className={classes.title} href={a._id} target="_blank">{a.title}</a></h2>
                    <p>{a.text}</p>
                    <MediaField record={a} />
                </div>
            </div>))}
            </TabContainer>}
            {value === 1 && <TabContainer>
              {this.state.logs.split('\n').map(text => (<span>{text}<br/></span>))}
            </TabContainer>}
        </Dialog>
      </div>
    );
  }
}

CrawledArticlesDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    record: PropTypes.object,
};

export default connect(state => ({ record: getFormValues('record-form')(state)}), {
    changeCategories: val => change('record-form', "categories", val),
})(withStyles(styles)(CrawledArticlesDialog));


// WEBPACK FOOTER //
// ./src/resources/ui/CrawledArticlesDialog.js